<template>
  <div class="flex flex-col gap-[40px]">
    <section class="flex flex-col">
      <p class="text-grays-900 text-base font-bold">לא קיבלתם קישור?</p>
      <div class="text-grays-900 text-base font-regular">
        <p v-if="isResendDisabled && !isLoading">
          <span class="font-semibold">{{ timer }}s </span>
          נסו שוב בעוד
        </p>
        <button
            v-if="!isResendDisabled && !isLoading"
            :disabled="isResendDisabled"
            class="focus:text-primary-900 active:text-primary-900 text-primary-500 hover:text-primary-800 font-bold underline cursor-pointer disabled:cursor-not-allowed"
            @click="submit"
        >
          תשלחו לי עוד פעם קישור
        </button>
      </div>
      <p v-if="isLoading" class="text-grays-900 text-base font-regular">
        טוען נתונים...
      </p>
      <error-block
          v-if="requestError.show && !requestSuccess"
          :errorMessage="requestError.message"
      />
      <success-block
          v-if="requestSuccess && !requestError.show"
          :message="'נשלח שוב אימייל'"
      />
    </section>
  </div>
</template>

<script>
import axiosInstance from "../../helpers/axios.js";

export default {
  name: "resend-password-verification",
  data() {
    return {
      isLoading: false,
      requestError: {
        show: false,
        message: "",
      },
      requestSuccess: false,
      isResendDisabled: false,
      timer: 60,
    };
  },
  methods: {
    async submit() {
      if (!this.isResendDisabled) {
        try {
          this.isLoading = true;
          await axiosInstance.post("/reset-password", {
            email: this.email,
          });
          // Hiding the request error in case it was true before.
          this.requestError.show = this.requestError.show === true && false;
          this.requestSuccess = true;
          this.startCooldown();
        } catch (e) {
          console.error(e.response.data.message);
          // Showing requestErrorBlock in case there is any request errors.
          this.requestError.show = true;
          // Showing requestErrorBlock with a specific error message.
          if (
              e.response &&
              e.response.data &&
              e.response.data.message !== undefined
          ) {
            this.requestError.message = e.response.data.message;
          }
        } finally {
          this.isLoading = false;
        }
      }
    },
    startCooldown() {
      this.isResendDisabled = true;
      this.timer = 60;
      const interval = setInterval(() => {
        this.timer--;
        if (this.timer === 0) {
          clearInterval(interval);
          this.isResendDisabled = false;
        }
      }, 1000);
    },
  },
  computed: {
    email() {
      return this.$store.getters["resetPassword/getEmail"];
    },
    cooldownTime() {
      return this.timer > 9 ? `0:${this.timer}` : `0:0${this.timer}`;
    },
  },
  mounted() {
    this.isResendDisabled = true;
    this.startCooldown();
  },
};
</script>

<style>
</style>
